<script>
import { ShowPageElementMixin } from "%/dynamic-component-editor/standard-pages/show-page/show-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "ShowDescription",
  elementPanelSettings: {
    displayName: "Description",
    displayIcon: "material-symbols:description",
    elementGroup: "show",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [ShowPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.description;
    },
  },
};
</script>
